import * as z from "zod";
import {
  Product2AttributeUpsertSchema,
  Product2AttributeValueUpsertSchema,
} from "./product2-attribute-types";
import {
  Product2UpsertSchema_,
  Product2VariantUpsertSchema_,
} from "./product2-types";

const Product2VariantInventoryUpsertSchema_ =
  Product2VariantUpsertSchema_.extend({
    attributeValues: z.array(Product2AttributeValueUpsertSchema),
    quantity: z.number().min(0),
  });
export const Product2VariantInventoryUpsertSchema: z.ZodType<Product2VariantInventoryUpsert> =
  Product2VariantInventoryUpsertSchema_;
export interface Product2VariantInventoryUpsert extends z.infer<
  typeof Product2VariantInventoryUpsertSchema_
> {}

const ProductInventoryUpsertSchema_ = Product2UpsertSchema_.extend({
  attributes: z.array(Product2AttributeUpsertSchema),
  variants: z.array(Product2VariantInventoryUpsertSchema),
});
export const ProductInventoryUpsertSchema: z.ZodType<ProductInventoryUpsert> =
  ProductInventoryUpsertSchema_;
export interface ProductInventoryUpsert extends z.infer<
  typeof ProductInventoryUpsertSchema_
> {}
